import { Icon } from '../Icon';

/**
 * 후기 화면의 잔 조각 — **서버·클라이언트가 함께 쓴다.**
 *
 * 목록(`ReviewList`)은 클라이언트, 보기(`ReviewView`)는 서버다. 클라이언트 파일에 두면
 * 서버가 부를 수 없다(실측 — `Attempted to call day() from the server but day is on the client`).
 * 그래서 지시어 없는 파일에 두고 양쪽이 가져다 쓴다.
 */

/** 별 다섯 — 반쪽까지(가이드 `rv-star`·`filled`·`half`) */
export function Stars({ score }: { score: number }) {
  return (
    <div className="rv-card-stars">
      {[1, 2, 3, 4, 5].map((i) => {
        const cls = score >= i ? 'filled' : score >= i - 0.5 ? 'half' : '';
        return <Icon key={i} name="star" size={14} className={`rv-star ${cls}`.trim()} />;
      })}
    </div>
  );
}

/**
 * 반쪽 별에 쓰는 그라디언트 — 가이드 CSS 가 `url(#halfGrad)` 로 참조하는데 **정의가 가이드
 * 어디에도 없다**(2026-09-05 확인). 없으면 4.5점이 빈 별로 보인다. 후기 화면에서만 쓰므로
 * 여기 한 번 둔다(셸에 두면 후기를 안 보는 화면까지 이 조각을 진다).
 */
export function HalfStarDef() {
  return (
    <svg width="0" height="0" aria-hidden style={{ position: 'absolute' }}>
      <defs>
        <linearGradient id="halfGrad" x1="0" x2="1" y1="0" y2="0">
          <stop offset="50%" stopColor="#f7b84b" />
          <stop offset="50%" stopColor="transparent" />
        </linearGradient>
      </defs>
    </svg>
  );
}

/** 목록 날짜 — `2026.08.28`(가이드 표기) */
export const day = (v: string) => String(v).slice(0, 10).replace(/-/g, '.');
